import api from '../config/gatewayConfig'
import { httpClient } from './httpClient'

const jsonPublicConfig = {
  skipAuth: true,
  skipGlobalErrorDispatch: true,
  headers: {
    "Content-Type": "application/json",
  },
};

// Fuso IANA del browser (es. "Europe/Rome"): il backend lo usa per mostrare
// nell'email l'orario di scadenza nell'ora locale di chi fa la richiesta.
const clientTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
};

const loginService = {
  login: async (data) => {
    try {
      const response = await httpClient.post(api.login, data, {
        skipAuth: true,
        skipGlobalErrorDispatch: true,
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      console.error("Errore login:", error);
      throw error;
    }
  },

  // timeZone: il backend mostra l'orario di scadenza nell'ora locale dell'utente
  requestRecoverPassword: async (payload) =>
    httpClient.post(api.requestRecoverPassword, { ...payload, timeZone: clientTimeZone() }, jsonPublicConfig),

  recoverPassword: async (payload) =>
    httpClient.post(api.recoverPassword, payload, jsonPublicConfig),

  refresh: async () => httpClient.post(api.refresh, {}),
};

if (api.apiMode !== "prod") {
    console.log(`Using API mode: "${api.apiMode}" with URL: ${api.apiBaseUrl}`);
}

export default loginService;